/**
 * The countries an account may be created in — `account.country`, ISO 3166-1 alpha-2.
 *
 * Added 2026-09-22 by plan-002 unit RB-17 (design §15.4.2, contradiction C20: `account.country`
 * is `NOT NULL` and sign-up used to collect none).
 *
 * ── THIS IS PRODUCT DATA, NOT A DEFAULT ─────────────────────────────────────────────────────
 *
 * A closed list. Sign-up and `POST /v1/accounts` refuse any code outside it with
 * `422 country_unsupported`; nothing ever picks a country on a person's behalf — the server never
 * guesses one, and the console never proposes one (§15.4.2). There is no "other" entry and no
 * fallback country.
 *
 * **Provisional, pending the product owner's confirmation.** No product decision names the
 * launch countries (Q4 covers number countries and is still open). This list is the reading of
 * what IS decided: EUR only (ADR 0014), an EEA payment processor (EveryPay), and the market-led
 * language set of Q15b — the EU-27, the three other EEA states, Switzerland and the United
 * Kingdom, plus Israel, where one of the two reference bots that ship first already runs (Hebrew
 * is in the first three packs). Turkey, Ukraine and the Arabic-speaking markets are in Q15b's
 * languages but not obviously in its markets; adding one is one line here and nothing else, and
 * removing one later is not free (accounts would exist in it). Russia is deliberately absent.
 *
 * Sorted by code so a diff shows exactly what moved. The console renders each code's display
 * name with `Intl.DisplayNames`, so no name is stored here to drift from the browser's own.
 */
export const SUPPORTED_COUNTRY = [
    "AT", // Austria
    "BE", // Belgium
    "BG", // Bulgaria
    "CH", // Switzerland
    "CY", // Cyprus
    "CZ", // Czechia
    "DE", // Germany
    "DK", // Denmark
    "EE", // Estonia
    "ES", // Spain
    "FI", // Finland
    "FR", // France
    "GB", // United Kingdom
    "GR", // Greece
    "HR", // Croatia
    "HU", // Hungary
    "IE", // Ireland
    "IL", // Israel
    "IS", // Iceland
    "IT", // Italy
    "LI", // Liechtenstein
    "LT", // Lithuania
    "LU", // Luxembourg
    "LV", // Latvia
    "MT", // Malta
    "NL", // Netherlands
    "NO", // Norway
    "PL", // Poland
    "PT", // Portugal
    "RO", // Romania
    "SE", // Sweden
    "SI", // Slovenia
    "SK", // Slovakia
];
const SUPPORTED = new Set(SUPPORTED_COUNTRY);
/**
 * Whether `code` is a supported country, exactly as `account.country` stores it: two upper-case
 * letters. A lower-case `gr` is NOT accepted and not silently upper-cased — the API documents the
 * upper-case form, and a client that sends anything else has a bug worth hearing about.
 */
export function isSupportedCountry(code) {
    return SUPPORTED.has(code);
}
//# sourceMappingURL=country.js.map